<template>
    <div>
        <template>
            <vs-row>
                <!-- for single image  -->
                <template v-if="!multiple">
                    <template v-if="!(images_obj.length == 1)">
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="px-0" v-if="!read_only">
                            <Uploader 
                                :multiple="false"
                                :extensions="['jpg', 'jpeg', 'png']"
                                @input="val => handleFilesSelected(val.files, val.source)"
                                upload_label="Upload"
                            />
                        </vs-col>
                    </template>
                </template>
                <!-- generic -->
                <template v-else>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="px-0" v-if="!read_only">
                        <label class="vs-input--label block mb-1">Upload Images (Max 5)</label>
                        <Uploader 
                            :multiple="true"
                            :extensions="['jpg', 'jpeg', 'png']"
                            @input="val => handleFilesSelected(val.files, val.source)"
                        />
                    </vs-col>
                </template>
            </vs-row>
            <!-- for embedded_mode  -->
            <div v-if="embedded_mode">
                <template v-for="(image, index) in images_obj.filter(filter)">
                    <vs-button v-if="image.status == 'u'" :key="'uploading-'+ index" color="warning" type="filled" size="small" class="w-full" :disabled="true">
                        Uploading
                    </vs-button>
                    <div v-else :key="'div-' + index" class="flex">
                        <vs-button :key="'view_image-'+ index" :color="image.status == 'c' ? 'success' : 'primary'" type="filled" size="small" class="px-1" :class="image.status && (image.status ==  'p' || image.status == 'f') ? 'w-2/3' : 'w-full'" @click="openExternalImage(image)" v-if="!image.status || image.status != 'u'">
                            View Image
                        </vs-button>
                        <vs-button :key="'cancel-'+ index" color="danger" type="filled" size="small" class="w-1/3 px-1" @click="images_obj.splice(index, 1)" v-if="image.status && (image.status ==  'p' || image.status == 'f')">
                            X
                        </vs-button>
                        <!-- for delete  -->
                        <template v-if="image.id && !read_only && can_delete">
                            <vs-button :key="'delete-' + index" color="danger" type="filled" size="small" class="w-1/3 px-1" @click="popup_delete_active=true">X</vs-button>
                            <vs-popup :key="'popup-' + index" :active.sync="popup_delete_active" class="image-popup" title="Delete Image">
                                <vs-row>
                                    <vs-col>
                                        <img :src="image.image" />
                                    </vs-col>
                                </vs-row>
                                <vs-row class="my-3">
                                    <vs-col>
                                        <h5>Are you sure you want to delete this image?, this action is not irreversible.</h5>
                                    </vs-col>
                                </vs-row>
                                <vs-row>
                                    <vs-col>
                                        <vs-button @click="() => {
                                            popup_delete_active = false
                                            $emit('delete_image', image)
                                        }" :disabled="disabled" color="danger">Yes</vs-button>
                                        <vs-button @click="popup_delete_active = false" :disabled="disabled" color="primary" class="mx-2">No</vs-button>
                                    </vs-col>
                                </vs-row>
                            </vs-popup>
                        </template>
                    </div>
                </template>
            </div>
            <!-- generic mode  -->
            <div v-else>
                <vs-row>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="px-0 mt-3">
                        <vs-row>
                            <vs-col vs-xs="6" vs-sm="3" vs-lg="3" class="mb-3 px-1" v-for="(image, index) in images_obj.filter(filter)" :key="index">
                                <a href="#" class="image-preview" :style="{backgroundImage: `url('${typeof(image.image) == 'string' ? image.image : image.local_image}')`}" @click="openExternalImage(image)"></a>
                                <vs-button :color="image.status == 'c' ? 'success' : 'primary'" type="filled" size="small" class="px-1" :class="image.status && (image.status ==  'p' || image.status == 'f') ? 'w-2/3' : 'w-full'" @click="openExternalImage(image)" v-if="!image.status || image.status != 'u'">
                                    View Image
                                </vs-button>
                                <vs-button color="danger" type="filled" size="small" class="w-1/3 px-1" @click="images_obj.splice(index, 1)" v-if="image.status && (image.status ==  'p' || image.status == 'f')">
                                    X
                                </vs-button>
                                <vs-button color="warning" type="filled" size="small" class="w-full" v-else-if="image.status == 'u'" :disabled="true">
                                    Uploading
                                </vs-button>
                            </vs-col>
                        </vs-row>
                    </vs-col>
                </vs-row>
            </div>
        </template>
        <vs-popup :active.sync="image_view.active" class="image-popup" title="Preview Image">
            <img :src="image_view.src" v-if="image_view.active" />
            <template v-if="image_view.active && image_view.created_on">
                <span class="mt-3">Uploaded on: <FormatText :text="image_view.created_on" format="datetime" /></span>
            </template>
        </vs-popup>
    </div>
</template>

<script>
import Uploader from "@/components/letstream/ls-drag-drop-uploader/Uploader.vue"
import { compressImage } from "@/utils/imageCompression.js"

export default {
    components: {
        Uploader
    },
    props: {
        images: {
            type: Array,
            default: () => [],
            required: true
        },
        filter: {
            type: Function,
            default: () => true,
            required: false
        },
        read_only: {
            type: Boolean,
            default: false,
            required: false
        },
        embedded_mode: {
            type: Boolean,
            required: false,
            default: false
        },
        multiple: {
            type: Boolean,
            required: false,
            default: true
        },
        can_delete: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            images_obj: this.images,

            image_view: {
                active: false,
                src: null,
                created_on: null
            },

            popup_delete_active: false,
            disabled: false
        }
    },
    watch: {
        images(newV) {
            this._set_by_watcher = true
            this.images_obj = newV
        },
        images_obj (newV) {
            if (this._set_by_watcher) {
                this._set_by_watcher = false
                return
            }
            this.$emit('update:images', newV)
        }
    },
    methods: {
        async handleFilesSelected(files, source) {
            if (!this.filter)
                this.images_obj = source == 'camera' ? this.images_obj : []
            else
                this.images_obj = this.images_obj.filter(val => !this.filter(val) || val.image_type === undefined )

            if (this.images_obj.filter(val => this.filter(val)).length >= 5) return

            if(!this.multiple) {
                const compressedFile = await this.compressImageFile(files);
                
                this.images_obj.push({
                    image: compressedFile,
                    local_image: await this.getImageBase(compressedFile),
                    status: 'p'
                })

            } else {
                for(let i=0; i<files.length; i++) {
                    let v = files[i]
                    const compressedFile = await this.compressImageFile(v);
    
                    this.images_obj.push({
                        image: compressedFile,
                        local_image: await this.getImageBase(compressedFile),
                        status: 'p'
                    })
    
                    if (this.images_obj.filter(val => this.filter(val)).length >= 5) break
                }
            }

        },
        loadImageInMemory(image) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader()
                reader.onload = (result) => resolve(result.target.result)
                reader.onerror = (e) => reject(e)
                reader.readAsDataURL(image);
            })
        },
        async getImageBase(image) {
            let data = await this.loadImageInMemory(image)
            return data
        },
        async compressImageFile(file) {
            try {
                const compressedFile = await compressImage(file, 400);
                return compressedFile;
            } catch (error) {
                return file;
            }
        },
        openExternalImage(image) {
            if (typeof(image.image) == 'string') {
                this.image_view.src = image.image
            } else {
                this.image_view.src = image.local_image
            }

            this.image_view.active = true
            this.image_view.created_on = image.created_on
        },
    }
}
</script>

<style lang="scss">
    .image-preview {
        width: 100%;
        height: 70px;
        background-size: cover;
        background-position: center;
        display: block;
    }

    .image-popup {
        text-align: center;
        img {
            max-width: 100%;
            max-height: 95vh;
            margin-left: auto;
            margin-right: auto;
        }
    }
</style>